import { createArrayIntentType } from '../../intent';
export const continuationIntent = createArrayIntentType('continuation', (decorate)=>(render)=>{
        return decorate(render);
    });

//# sourceMappingURL=continuation.js.map